import React from 'react';
import Image from 'next/image';
import campusrankimg from "../../public/images/rank2.png";
import layer1 from "../../public/images/layer1.png";
import rankred from "../../public/images/blue.png";

const CampusRank = () => {
  return (
    <>
        <div className='bg-[#ecebeba6]  relative'>
          <div className='2xl:mx-24 xl:mx-20 lg:mx-20 md:mx-20 sm:mx-10 mx-5 '>
            <div className='grid grid-cols-1 lg:grid-cols-2 gap-14 items-center justify-center'>
              <div className='relative flex justify-center lg:justify-end w-full h-full'>
                <Image src={rankred} alt='campus hiring software' className='w-full h-auto' />
                <div className='absolute inset-0 flex justify-center items-center'>
                  <Image src={campusrankimg} alt='virtual hiring software' width={350} height={350} className='lg:w-auto w-[300px] lg:mr-9 lg:mb-20 mr-3 mb-10 h-auto' />
                </div>
              </div>
              <div className='text-start flex z-10 flex-col justify-center lg:ml-10 lg:mt-[-2rem] mt-[-6rem] mb-12'>
                <h2 className='text-[#41b8ea] lg:text-3xl text-xl font-bold '>EASYCAMPUS RANKED #1</h2>
                <p className='lg:text-4xl text-2xl mb-2 font-bold lg:leading-[45px]'>
                  As we create community of stakeholders who choose you every time.
                </p>
                <div className='lg:text-3xl text-xl flex flex-col space-y-2 pt-2'>
                  <div className='flex items-center'>
                    <span className='mt-1'>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                      </svg>
                    </span>
                    &nbsp;&nbsp;In data driven process
                  </div>
                  <div className='flex items-center'>
                    <span className='mt-1'>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                      </svg>
                    </span>
                    &nbsp;&nbsp;In end-to-end campus drive process
                  </div>
                  <div className='flex items-center'>
                    <span className='mt-1'>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                      </svg>
                    </span>
                    &nbsp;&nbsp;In easy-to-use methodology
                  </div>
                  <div className='flex items-center'>
                    <span className='mt-1'>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                      </svg>
                    </span>
                    &nbsp;&nbsp;In latest technologies
                  </div>
                  <div className='flex items-center'>
                    <span className='mt-1'>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
                      </svg>
                    </span>
                    &nbsp;&nbsp;In analytics and reports
                  </div>
                </div>
              </div>
            </div>
            <div className='absolute top-[150px] right-0 left-0 bottom-0 -z-0 w-full h-full'>
              <Image src={layer1} alt='campus hiring automation software' className=' relative -z-0 w-full h-full' />
            </div>
          </div>
        </div>
    </>
  )
}

export default CampusRank